import { Fragment } from 'react'
import { Popover, Transition } from '@headlessui/react'
import { HiChartPie, HiSquaresPlus, HiSquares2X2, HiMegaphone } from 'react-icons/hi2'
import { TbDeviceAnalytics } from "react-icons/tb";
import { RiRoadMapLine } from "react-icons/ri";
import { MdOutlineSupport } from "react-icons/md";
import NavLink from './NavLink';

const routes = [
  { name: 'Tenants', description: 'Create and manage several tenants', href: 'tenants.manage', icon: HiSquaresPlus },
  { name: 'Resources & Usage', description: 'Tracking tenants resources as well as usage', href: 'usages.manage', icon: HiChartPie },
  { name: 'Announcements', description: 'Tenants features and maintainance notifications channel', href: 'announcements.manage', icon: HiMegaphone },
  { name: 'Insights', description: 'Check application health and performance', href: 'insights.manage', icon: TbDeviceAnalytics },
]

const actions = [
  { name: 'RoadMap', href: 'roadmap', icon: RiRoadMapLine },
  { name: 'Support', href: 'tickets.manage', icon: MdOutlineSupport },
]

export default function FlyOutMenu({ header }) {
  return (
    <Popover className="relative">
      <Popover.Button className="flex justify-center items-center gap-x-1 text-sm font-medium leading-5 transition duration-150 ease-in-out focus:outline-none drop-shadow-md">

        <HiSquares2X2 className="block my-4 ml-2 lg:my-8 lg:ml-0 h-8 w-auto fill-current text-slate-400" aria-hidden="true" />

        <h3 className="mx-2 text-base lg:text-xl font-medium text-slate-800 leading-tight border-b-2 border-emerald-400">
            {header}
        </h3>
      </Popover.Button>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <Popover.Panel className="absolute left-1/2 z-10 mt-2 flex w-screen max-w-max -translate-x-1/2 px-4 mx-[4.5rem] lg:mx-40">
          <div className="w-screen max-w-md flex-auto overflow-hidden rounded-3xl bg-white text-sm leading-6 shadow-lg ring-1 ring-slate-900/5">
            <div className="p-4">
              {routes?.map((item) => (
                <div key={item?.name} className={`group relative flex gap-x-6 rounded-lg p-4 hover:bg-slate-50 ${item?.name === header ? "bg-stone-50" : ""}`}>
                  <div className="mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-slate-50 group-hover:bg-white">
                    <item.icon className={`h-6 w-6 group-hover:text-emerald-400 ${item?.name === header ? "text-emerald-500" : "text-slate-600"}`} aria-hidden="true" />
                  </div>
                  <div>
                    <NavLink href={route(item?.href)} active={item?.name === header} className="font-semibold text-slate-900">
                        {item?.name}
                    <span className="absolute inset-0" />
                    </NavLink>
                    <p className="mt-1 text-slate-600">{item?.description}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="grid grid-cols-2 divide-x divide-slate-900/5 bg-slate-50">
              {actions?.map((item) => (

                <NavLink
                key={item?.name}
                href={route(item?.href)}
                active={item?.name === header}
                className={`group relative flex items-center justify-center gap-2.5 p-3 font-semibold text-slate-900 hover:bg-slate-100 ${item?.name === header ? "bg-stone-100" : ""}`}
                >
                    <item.icon className={`h-5 w-5 flex-none group-hover:text-emerald-400 ${item?.name === header ? "text-emerald-500" : "text-slate-600"}`} aria-hidden="true" />
                    {item?.name}
                </NavLink>

              ))}
            </div>
          </div>
        </Popover.Panel>
      </Transition>
    </Popover>
  )
}
